import { useState } from 'react';
import React from 'react';
import 'quill/dist/quill.snow.css';
import { Button } from '../button/Button';
import { ButtonRow } from '../button/ButtonRow';
import ReactQuill from 'react-quill';
import { HtmlEditor } from './HtmlEditor';

type HtmlEditorWithSaveProps =
    {
        id: string,
        value: string,
        onSave: (content: string) => void,
        onCancel?: () => void,
        onBlur?: () => void,
        placeholder?: string,
        readonly?: boolean,
        debugPanel?: boolean,
        innerRef?: React.LegacyRef<ReactQuill>,
    };

export function HtmlEditorWithSave (props: HtmlEditorWithSaveProps): JSX.Element
{
    const [editorContent, setEditorContent] = useState(props.value);

    React.useEffect(() =>
    {
        setEditorContent(props.value);
    }, [props.value]);

    const handleEditorChange = (content: string) =>
    {
        setEditorContent(content);
    };

    const changed = props.value !== editorContent;

    return (
        <div>
            <HtmlEditor
                id={props.id}
                value={editorContent}
                onChange={handleEditorChange}
                onBlur={props.onBlur}
                placeholder={props.placeholder}
                readonly={props.readonly}
                debugPanel={props.debugPanel}
                innerRef={props.innerRef}
            />
            <ButtonRow style={{ marginTop: '4px' }}>
                <Button variant="filled" text="Gem" disabled={props.readonly || !changed} onClick={() => props.onSave(editorContent)} />
                <Button variant="outlined" text="Annuller" disabled={props.readonly || !changed}
                    onClick={() =>
                    {
                        setEditorContent(props.value);
                        props.onCancel?.();
                    }} />
            </ButtonRow>
        </div>
    );
}